import { render, staticRenderFns } from "./ledgerLogDetail.vue?vue&type=template&id=5243080a&scoped=true"
import script from "./ledgerLogDetail.vue?vue&type=script&lang=js"
export * from "./ledgerLogDetail.vue?vue&type=script&lang=js"
import style0 from "./ledgerLogDetail.vue?vue&type=style&index=0&id=5243080a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5243080a",
  null
  
)

export default component.exports